// extracted by mini-css-extract-plugin
export default {"sys":"Sys_sys__SagPE"};